import clsx from "clsx";

type Props = {
  total: number;
  current: number;
  onDotClick: (index: number) => void;
};

export function MobileWidgetPagination({ total, current, onDotClick }: Props) {
  if (total <= 1) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 h-10 flex items-center justify-center gap-2 sm:hidden z-50 bg-gray-100 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      {Array.from({ length: total }).map((_, i) => (
        <button
          key={i}
          onClick={() => onDotClick(i)}
          aria-label={`Go to widget ${i + 1}`}
          className={clsx(
            "w-2.5 h-2.5 rounded-full transition-all duration-200",
            i === current
              ? "bg-squawk-blue scale-110"
              : "bg-gray-400 dark:bg-gray-500 hover:bg-gray-500 dark:hover:bg-gray-400"
          )}
        />
      ))}
    </div>
  );
}
